module.exports = __webpack_public_path__ + "static/media/cpg_mobileweb_unsafecars_banner.abde4cf9.png";